import { withNamespaces } from "react-i18next";
import { Badge } from "reactstrap";

import "./style.scss";

const PRIORITY_BADGE_COLORS = {
    critical: "danger",
    high: "danger",
    medium: "warning",
    normal: "info",
    low: "success"
};

const PRIORITY_LABELS = {
    critical: "Critical",
    high: "High",
    medium: "Medium",
    normal: "Normal",
    low: "Low"
};

const getPriorityKey = (priority) => {
    if (!priority || typeof priority !== "string") {
        return "";
    }

    return priority.trim().toLowerCase();
};

/**
 * Renders an assessment-gap notice for a questionnaire question.
 * Presentation only — no resolve or document actions.
 *
 * @param {Object} props
 * @param {Object} props.gap
 * @param {Function} props.t
 */
const AssessmentGapNotice = ({ gap, t }) => {
    if (!gap) {
        return null;
    }

    const priorityKey = getPriorityKey(gap.priority);
    const priorityLabel = PRIORITY_LABELS[priorityKey];
    const description = typeof gap.description === "string"
        ? gap.description.trim()
        : "";

    return (
        <div className="assessment-gap-notice" role="status">
            <div className="assessment-gap-notice__badges">
                <Badge className="assessment-gap-notice__badge">
                    {t("Assessment Gap")}
                </Badge>

                {priorityLabel && (
                    <Badge
                        color={PRIORITY_BADGE_COLORS[priorityKey] || "secondary"}
                        className="assessment-gap-notice__priority"
                        pill
                    >
                        {t(priorityLabel)}
                    </Badge>
                )}
            </div>

            {gap.title && (
                <div className="assessment-gap-notice__title">
                    {gap.title}
                </div>
            )}

            {description && (
                <div className="assessment-gap-notice__description">
                    {description}
                </div>
            )}
        </div>
    );
};

export default withNamespaces()(AssessmentGapNotice);
